<template>
  <div class="checkin-aggiornato">
    <br />

    <div v-if="nome_file_logo != '' && nome_file_logo != undefined">
      <b-img
        :src="nome_file_logo"
        fluid-grow
        alt="Logo strutture"
        v-if="nome_file_logo != ''"
        style="max-height: 152px"
      ></b-img>
      <br />
      <br />
    </div>

    <h2>{{ labels.i_dati_sono_stati_aggiornati }}</h2>
    <br />

    <div v-if="canale == 'BACKOFFICE'">
      <p>
        {{ labels.stampa_di_controllo }}
        <b-button
          variant="success"
          @click="stampa_riepilogo"
          :disabled="invio_in_corso"
          >{{ labels.clicca_qui }}.</b-button
        >
      </p>
      <br />
      <b-link @click="RitornaABackoffice">Torna a backoffice</b-link>
    </div>
    <div v-else>
      <div v-if="indirizzo_email != ''">
        <p>{{ labels.un_email_e_stata_inviata }}: {{ indirizzo_email }}</p>
        <p>
          {{ labels.se_desideri }}
          <b-button
            variant="success"
            @click="stampa_riepilogo"
            :disabled="invio_in_corso"
            >{{ labels.clicca_qui }}.</b-button
          >
        </p>
      </div>
      <div v-else>
        <p>
          {{ labels.per_avere_una_stampa }}
          <b-button
            variant="success"
            @click="stampa_riepilogo"
            :disabled="invio_in_corso"
            >{{ labels.clicca_qui }}.</b-button
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "CheckInAggiornato",
  components: {},
  data() {
    return {
      labels: {},
      labels_errori: {},
      invio_in_corso: false,
    };
  },
  props: {
    canale: String,
    origine: String,
    struttura: String,
    descrizione_struttura: String,
    indirizzo_email: String,
    reservation_code: String,
    nome_file: String,
    nome_file_logo: String,
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  methods: {
    RitornaABackoffice() {
      try {
        this.$router.push("/amministrazione/backoffice");
      } catch (error) {
        this.registraErrore(error, "CheckInAggiornato-RitornaABackoffice");
      }
    },
    stampa_riepilogo() {
      try {
        let me = this;
        let ServerURL = this.$store.state.ServerURL;

        fn_CambiaCursore("wait", this);

        axios({
          method: "get",
          url:
            ServerURL +
            "CheckIn/StampaRiepilogo?canale=" +
            this.canale +
            "&origine=" +
            this.origine +
            "&reservationcode=" +
            this.reservation_code +
            "&struttura=" +
            this.struttura,
          responseType: "json",
        })
          .then(function (response) {
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              //window.open(response.data.oggetto, "_blank");
              window.open(response.data.oggetto, "_self");
            } else if (response.data.errore == -2) {
              me.registraErrore(
                response.data.esito,
                "CheckInAggiornato-stampa_riepilogo"
              );
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "CheckInAggiornato-stampa_riepilogo");
          });
      } catch (error) {
        this.registraErrore(error, "CheckInAggiornato-stampa_riepilogo");
      }
    },
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
    } catch (error) {
      this.registraErrore(error, "CheckInAggiornato-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      i_dati_sono_stati_aggiornati:
        "I dati sono stati aggiornati correttamente",
      stampa_di_controllo:
        "Per avere una stampa di controllo dei dati inseriti, ",
      clicca_qui: "clicca qui",
      un_email_e_stata_inviata:
        "Un email con il riepilogo dei dati inseriti è stata inviata all'indirizzo",
      se_desideri:
        "Se desideri avere subito una stampa in PDF dei dati inseriti, ",
      per_avere_una_stampa:
        "Per avere una stampa dei dati inseriti da presentare alla reception della struttura,",
    };

    let labels_inglese = {
      i_dati_sono_stati_aggiornati: "The data has been updated correctly.",
      stampa_di_controllo: "To get a check printout of the data entered, ",
      clicca_qui: "click here",
      un_email_e_stata_inviata:
        "An email with the summary of the data entered was sent to",
      se_desideri:
        "If you wish to have a PDF print of the entered data immediately, ",
      per_avere_una_stampa:
        "To have a print of the entered data to present at the reception of the structure, ",
    };
    let labels_tedesco = {
      i_dati_sono_stati_aggiornati: "Die Daten wurden korrekt aktualisiert.",
      stampa_di_controllo:
        "Per avere una stampa di controllo dei dati inseriti, ",
      clicca_qui: "hier klicken",
      un_email_e_stata_inviata:
        "Eine E-Mail mit der Zusammenfassung der eingegebenen Daten wurde gesendet an",
      se_desideri:
        "Wenn Sie die eingegebenen Daten sofort als PDF drucken lassen möchten, ",
      per_avere_una_stampa:
        "Um einen Ausdruck der eingegebenen Daten an der Rezeption der Struktur vorzulegen, ",
    };
    let labels_francese = {
      i_dati_sono_stati_aggiornati: "The data has been updated correctly.",
      stampa_di_controllo: "To get a check printout of the data entered, ",
      clicca_qui: "click here",
      un_email_e_stata_inviata:
        "An email with the summary of the data entered was sent to",
      se_desideri:
        "If you wish to have a PDF print of the entered data immediately, ",
      per_avere_una_stampa:
        "To have a print of the entered data to present at the reception of the structure, ",
    };

    let labels_errori_italiano = {
      prenotazione_non_trovata: "Prenotazione non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_inglese = {
      prenotazione_non_trovata: "Prenotazione non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_tedesco = {
      prenotazione_non_trovata: "Prenotazione non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };
    let labels_errori_francese = {
      prenotazione_non_trovata: "Prenotazione non trovata",
      si_e_verificato_un_errore: "Si è verificato un errore",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "CheckInAggiornato-fn_CambiaLingua");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>
